/**
 * METABOLIC SERVICE (Industry Standard)
 * Proxy layer for MetabolicCompute logic.
 */

import { Event } from '@/types/zod.schemas';
import { MetabolicCompute } from '@/shared/logic/metabolic-logic';

export const MetabolicService = {
    normalizeLedgerItems(payload: any): any[] {
        return MetabolicCompute.normalizeLedgerItems(payload);
    },

    calculateLedgerTotals(items: any[]): any {
        return MetabolicCompute.calculateLedgerTotals(items);
    },

    sanitizeMacroValue(field: string, value: string): number | string {
        return MetabolicCompute.sanitizeMacroValue(field, value);
    },

    getTacticalNutritionTip(totals: any): string | null {
        return MetabolicCompute.getTacticalNutritionTip(totals);
    },

    getWalkingMET(kmh: number): number {
        return MetabolicCompute.getWalkingMET(kmh);
    },

    calculateCardioBaseline(
        weightKg: number, 
        durationMins: number, 
        distanceKm: number = 0, 
        intensityPercent: number = 50
    ): number {
        return MetabolicCompute.calculateCardioBaseline(weightKg, durationMins, distanceKm, intensityPercent);
    },

    calculateStrengthBaseline(
        tonnageKg: number, 
        weightKg: number, 
        durationMins: number, 
        avgRpe: number = 7
    ): number {
        return MetabolicCompute.calculateStrengthBaseline(tonnageKg, weightKg, durationMins, avgRpe);
    },

    aggregateDayNutrition(events: Event[], dateStr: string) {
        return MetabolicCompute.aggregateDayNutrition(events, dateStr);
    },

    aggregateDaySupplements(events: Event[], dateStr: string) {
        return MetabolicCompute.aggregateDaySupplements(events, dateStr);
    },

    mergeMetabolicLoad(nutrition: any, supplements: any) {
        return MetabolicCompute.mergeMetabolicLoad(nutrition, supplements);
    },

    aggregateTrainingBurn(events: Event[], dateStr: string): number {
        return MetabolicCompute.aggregateTrainingBurn(events, dateStr);
    },

    calculateDynamicTargets(profile: any, trainingBurn: number, caloriesConsumed: number) {
        return MetabolicCompute.calculateDynamicTargets(profile, trainingBurn, caloriesConsumed);
    },

    calculateBMR(gender: string, heightCm: number, weightKg: number, birthDate: string, bodyFatPercentage?: number | null): number {
        return MetabolicCompute.calculateBMR(gender, heightCm, weightKg, birthDate, bodyFatPercentage);
    }
};
